import React, { useEffect, useRef, useState } from "react";
import "./ChatInput.css";
import Send from "../assets/Send.svg";
import KshemaLogo from "../assets/KshemaLogo.svg";
import axios from "axios";
import {
  authenticateAfterOTPValidation,
  generateMessage,
  generateMessageStream,
  getAllData,
  getCodeId,
  getOTP,
  verifyOTP,
} from "../services/apiConstant";
import { generatePKCEParams, getFromLocalStorage } from "../utils/Util";
import {
  API_STATUS,
  ROLE,
  STATUS_MESSAGE,
  STORAGE_KEY,
} from "../utils/Constant";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowUp from "../assets/ArrowUp.svg";
import ArrowDown from "../assets/ArrowDown.svg";
import Microphone from "../assets/Microphone.svg";
import { v4 as uuidv4 } from "uuid";
import { refreshAuthToken } from "../utils/AuthUtils";

import { Streamdown } from "streamdown";

interface ReturnMessage {
  content: string;
  forLogin?: boolean;
}
interface ChatInputProps {
  message: string;
  setMessage: (newMessage: string) => void;
}
interface Message {
  role: string;
  content: string;
  forLogin?: boolean | null;
  feedback?: "like" | "dislike" | null;
  isStreaming?: boolean;
  hasStarted?: boolean;
}
interface RequestMessage {
  role: string;
  content: string;
}
const LOGIN_STAGE = {
  MOBILE_NUMBER: "mobile_number",
  OTP_VERIFICATION: "otp_verification",
  OTP_VERIFICATION_IN_PROGRESS: "otp_verification_progress",
  OTP_VERIFICATION_ERROR: "otp_verification_error",
  OTP_VERIFIED: "otp_verified",
};
const ChatInput: React.FC<ChatInputProps> = ({ message, setMessage }) => {
  const [chatHistory, setChatHistory] = useState<Message[]>([]);

  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");
  const [userName, setUserName] = useState<string | null>(null);
  const [otpReferenceId, setOtpReferenceId] = useState<string | null>(null);
  const [codeId, setCodeId] = useState<string | null>(null);
  const [visibleCommentIndex, setVisibleCommentIndex] = useState<number | null>(
    null
  );
  const commentBoxRef = useRef<HTMLDivElement>(null);
  const [isCopied, setIsCopied] = useState(false);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const [uuid, setUuid] = useState(null);
  // const [sessionResponse, setSessionResponse] = useState(null);
  // const [stateResponse, setStateResponse] = useState(null);
  const [feedbackId, setFeedbackId] = useState<string | null>(null);
  const [selectLanguage, setSelectLanguageLocal] = useState<string>("eng_Latn");
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);
  const [isRecording, setIsRecording] = useState(false);
  const [audioUploading, setAudioUploading] = useState(false);
  const [verifierAndChallenge, setVerifierAndChallenge] = useState<any>();

  const [selectLanguageName, setSelectLanguageName] =
    useState<string>("English");
  const [queryNum, setQueryNum] = useState<number>(1);
  const [traceIds, setTraceIds] = useState<string[]>([]);
  const [loginStage, setLoginState] = useState<string | null>(null);

  const languageOptions = [
    { name: "English", code: "eng_Latn" },
    { name: "Telugu", code: "tel_Telu" },
    { name: "Hindi", code: "hin_Deva" },
    { name: "Tamil", code: "tam_Taml" },
  ];

  const token = "some-string";
  // const API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

  const authData: any = JSON.parse(getFromLocalStorage(STORAGE_KEY.AUTH_DATA));
  const email = authData?.email;

  // const API_BASE_URL = "https://nonprod-origin.kshema.co/db/api/v1";
  // const SUPERVISOR_API_URL = "https://nonprod-origin.kshema.co/supervisor/api/v1";

  


  useEffect(() => {
    const refreshToken = async () => {
      await refreshAuthToken(authData?.resetToken);
    };
    refreshToken();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { uuid } = await getAllData(token, email);
        setUuid(uuid);
        //setSessionResponse(sessionResponse);
        //setStateResponse(stateResponse);
        // setApiResponse(apiResponse);
        // console.log(uuid);
        // console.log(sessionResponse);
      } catch (error) {
        console.error("Failed to fetch data.", error);
      }
    };
    fetchData();
  }, []);

  //Log pre and post responses logs

  const logMessage = async (
    sessionId: string,
    messageType: "display" | "process",
    role: "user" | "assistant" | "feedback",
    message: string
  ) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/chat/log_session`,
        {
          session_id: sessionId,
          message_type: messageType,
          message,
          role,
          // token,
        }
      );
    } catch (error) {
      console.error(`Failed to log ${messageType} message`, error);
    }
  };

  const isValidMobileNumber = (mobileNumber: string) => {
    const regex = /^\d{10}$/;
    return regex.test(mobileNumber);
  };

  const sendMessage = async () => {
    if (!message.trim()) return;

    setQueryNum(queryNum + 1);
    
    setMessage("");

  

    if (!loginStage || loginStage === LOGIN_STAGE.OTP_VERIFIED) {
      addToChatHistory(ROLE.USER, {content: message, forLogin: false});
      //await handleNormalChat(trace, span);
      await handleNormalChat();
    } else {
      addToChatHistory(ROLE.USER, {content: message, forLogin: true});
      //await handleLoginFlow(trace, span);
      await handleLoginFlow(null, null);
    }
  };


  const addToChatHistory = (role: string, data: ReturnMessage) => {
    setChatHistory((prev) => [
      ...prev,
      {
        role,
        content: data?.content,
        forLogin: data?.forLogin,
      },
    ]);
  };
const buildRequestParam = () => {
  const history: RequestMessage[] = [];
  chatHistory?.forEach((item) => {
    if (!item?.forLogin) {
      history.push({
        role: item?.role,
        content: item?.content,
      });
    }
  });
  return {
    messages: history,
    query: message,
    session_id: uuid,
    span_id: "",
    target_language: selectLanguage,
    trace_id: "",
    email_id: email, 
  };
};

  // const handleNormalChat = async (trace: any, span: any) => {
  //   setLoading(true);
  //   setLoginState(null);
  //   const response: any = await generateMessage(buildRequestParam());
  //   setLoading(false);

  //   let messageData: ReturnMessage = getBotResponse(response);
  //   const finalBotText = messageData?.content

  //   finalizeResponse(trace, span, {content: finalBotText, forLogin: messageData?.forLogin});
  // };
  const handleNormalChat = async () => {
    setLoading(true);
    setLoginState(null);

    let assistantIndex = -1;

    // ✅ STEP 1: create EMPTY assistant message (stream placeholder)
    setChatHistory((prev) => {
      assistantIndex = prev.length;
      return [
        ...prev,
        {
          role: ROLE.ASSISTANT,
          content: loadingMessages[selectLanguage] || "Generating...",
          forLogin: false,
          isStreaming: true,
          hasStarted: false,
        },
      ];
    });
    

    // ✅ STEP 2: start streaming
    await generateMessageStream(
      buildRequestParam(),

      // ✅ onToken → runs MANY times
      (token: string) => {
        setChatHistory((prev) => {
          const updated = [...prev];
          const msg = updated[assistantIndex];

          //  ADD THIS CLEANING LOGIC
        
      let cleanToken = token;

          //  FORCE bullets to always start on new line
          cleanToken = cleanToken.replace(/(^|[^\\n])-\s/g, (match, p1) => {
            return p1 + "\n- ";
          });


          updated[assistantIndex] = {
            ...msg,
            content: msg.hasStarted
            ? msg.content.concat(cleanToken)
            : cleanToken,
            hasStarted: true,
          };

          return updated;
        });
      },

     () => {
  setChatHistory((prev) => {
    const updated = [...prev];
    updated[assistantIndex] = {
      ...updated[assistantIndex],
      isStreaming: false, 
    };
    return updated;
  });

  setLoading(false);
},

      (error: any) => {
        setLoading(false);

        const errorMsg =
          error?.error ||
          error?.message ||
          "";

        setChatHistory((prev) => {
          const updated = [...prev];

          for (let i = updated.length - 1; i >= 0; i--) {
            if (updated[i].role === ROLE.ASSISTANT && updated[i].isStreaming) {
              // OTP required case
              if (errorMsg.includes("otp_required")) {
                updated[i] = {
                  role: ROLE.ASSISTANT,
                  content: STATUS_MESSAGE.LOGIN_REQUIRED,
                  forLogin: true,
                  isStreaming: false,
                  hasStarted: true,
                };
              } 
              else {
                updated[i] = {
                  role: ROLE.ASSISTANT,
                  content: STATUS_MESSAGE.SOMETHING_WRONG,
                  forLogin: false,
                  isStreaming: false,
                  hasStarted: true,
                };
              }
              break;
            }
        }

        return updated;
      });

      // ✅ Trigger OTP flow only for OTP case
      if (errorMsg.includes("otp_required")) {
        setLoginState(LOGIN_STAGE.MOBILE_NUMBER);
        return;
      }

      // ✅ Generic error toast
      toast.error(STATUS_MESSAGE.SOMETHING_WRONG);
    },


    );
  };
  const finalizeText = (text: string) => {
      return text
        .replace(/\n(?!\n)/g, " ")   // merge broken lines
        .replace(/\s+/g, " ")        // clean extra spaces
        .trim();
    };


  const getBotResponse = (response: any) => {
    if (
      response?.response?.data?.otp_validated === API_STATUS.OTP_NOT_VERIFIED
    ) {
      setLoginState(LOGIN_STAGE.MOBILE_NUMBER);
      return { content: STATUS_MESSAGE.LOGIN_REQUIRED, forLogin: true };
    }
    if (response?.data?.status === API_STATUS.OPERATION_SUCCESSFUL) {
      return {
        content: response.data?.response || STATUS_MESSAGE.NO_RESPONSE,
        forLogin: false,
      };
    }
    return {
      content: response?.data?.response || STATUS_MESSAGE.ERROR_FETCHING,
      forLogin: false,
    };
  };


  const handleLoginFlow = async (trace: any, span: any) => {
    let returnMessage: any;
    if (loginStage === LOGIN_STAGE.MOBILE_NUMBER) {
      returnMessage = await processMobileNumber(message);
      if(returnMessage?.content === STATUS_MESSAGE.RETRY_THIS){
        returnMessage = await processMobileNumber(returnMessage?.message);
      }
    } else if (loginStage === LOGIN_STAGE.OTP_VERIFICATION) {
      returnMessage = await processOTPVerification(message);
    }
    finalizeResponse(trace, span, returnMessage);
  };

  const processMobileNumber = async (mobile: string) => {
    if (!isValidMobileNumber(mobile))
      return { content: STATUS_MESSAGE.ENTER_VALID_MOBILE, forLogin: true };
    setLoginState(LOGIN_STAGE.OTP_VERIFICATION);
    setLoading(true);
    setUserName(mobile);

    const otpResponse = await getOTP({
      recipient: mobile,
      channelType: "SMS",
      language: "en_us",
      placeholders: { user: "user" },
    });
    if(otpResponse?.status === API_STATUS.FAILED && 
      otpResponse?.errors?.length > 0 &&
      otpResponse?.errors[0]?.message?.includes("Jwt expired")) {
        await refreshAuthToken(authData?.resetToken);
        return { content: STATUS_MESSAGE.RETRY_THIS, forLogin: true, message: mobile };
    }
    setLoading(false);
    

    if (otpResponse?.status === 200 && otpResponse?.message === "OTP Sent") {
      setOtpReferenceId(otpResponse?.data?.referenceId);
      const { verifier, challenge } = generatePKCEParams();
      setVerifierAndChallenge({ verifier, challenge });
      const codeIdResponse = await getCodeId({
        clientId: "Kshema2.0",
        codeChallenge: challenge,
        codeChallengeMethod: "S256",
      });
      setCodeId(codeIdResponse?.data[0]?.codeId);
      return { content: STATUS_MESSAGE.ENTER_OTP, forLogin: true };
    }
    setOtpReferenceId(null);
    setCodeId(null);
    return { content: STATUS_MESSAGE.SOMETHING_WRONG, forLogin: true };
  };

  const processOTPVerification = async (otp: string) => {
    setLoginState(LOGIN_STAGE.OTP_VERIFICATION_IN_PROGRESS);
    setLoading(true);

    const verifyResponse = await verifyOTP({
      codeId,
      codeVerifier: verifierAndChallenge?.verifier,
      codeExchangeType: "BOTH",
      username: userName,
      otp,
      otpIdentifier: otpReferenceId,
    });
    setLoading(false);

    if (verifyResponse?.status === API_STATUS.STATUS_SUCCESS) {
      setLoading(true);
      setLoginState(LOGIN_STAGE.OTP_VERIFIED);
      const response = await authenticateAfterOTPValidation({
        additional_data: verifyResponse?.data[0],
        mobile_number: userName,
        session_id: uuid,
        span_id: "",
        trace_id: "",
      });
      setLoading(false);
      return {
        content:
          response?.status === API_STATUS.OPERATION_SUCCESSFUL
            ? STATUS_MESSAGE.OPT_VERIFIED
            : STATUS_MESSAGE.OPT_VERIFICATION_ERROR,
        forLogin: true,
      };
    }
    setLoginState(LOGIN_STAGE.MOBILE_NUMBER);
    return { content: STATUS_MESSAGE.OPT_VERIFICATION_ERROR, forLogin: true };
  };

  const finalizeResponse = (trace: any, span: any, data: ReturnMessage) => {
    //trace.span({ name: "Post-request processing" }).end({});
    addToChatHistory(ROLE.ASSISTANT, data);
    //span.end({ output: data?.content });
    //trace.update({ output: data?.content });
  };

  // Helper function to format bot response based on newlines
  /*const formatBotResponse = (response: any) => {
    const lines = response
      .split("\n")
      .filter((line: string) => line.trim() !== "");

    return lines.map((line: string, index: React.Key | null | undefined) => {
      if (line.match(/^\d+\./)) {
        // If the line starts with a number (e.g., 1. 2.), render it as a list item
        return <p key={index}>{line.trim()}</p>;
      } else {
        // Otherwise, render it as a paragraph
        return <p key={index}>{line.trim()}</p>;
      }
    });
  };*/

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory]);

  const sendFeedback = async (rating: number, index: number) => {
    let userMessage, botResponse;

    for (let i = index; i >= 0; i--) {
      if (chatHistory[i].role === "user") {
        userMessage = chatHistory[i].content;
        botResponse = chatHistory[i + 1]?.content;
        break;
      }
    }

    // console.log("Checking Feedback Pairing...");
    // console.log("User message:", userMessage);
    // console.log("Bot response:", botResponse);

    if (!userMessage || !botResponse) {
      console.error(
        "Missing user message or assistant response. Cannot send feedback."
      );
      return;
    }

    const query = userMessage;
    const response = botResponse;
    
    try {
      const apiResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/store_rating`,
        {
          display_messages: [
            { content: userMessage, role: ROLE.USER },
            { content: botResponse, role: "assistant" },
          ],
          process_messages: [
            { content: userMessage, role: ROLE.USER },
            { content: botResponse, role: "assistant" },
          ],
          query: query,
          rating: rating,
          response: response,
          session_id: uuid,
          email_id: email,
          trace_id: "",
          span_id: "",
          // token,
        }
      );
      if (apiResponse.data && apiResponse.data.feedback_id) {
        setFeedbackId(apiResponse.data.feedback_id);
        toast.success("Feedback saved successfully!");
      }
      // const logMessageResponse =  await logMessage(
      //   uuid!,
      //   "process",
      //   "feedback",
      //   JSON.stringify({ rating })
      // );
      // console.log("Feedback rating logged:", logMessageResponse);
    } catch (error) {
      console.error("Failed to send feedback:", error);
    }
  };

  const handleThumbsUp = (index: number) => {
    // console.log("Thumbs Up clicked at index:", index);

    if (chatHistory[index].feedback === "like") {
      console.log("Already liked.");
      return;
    }

    setChatHistory((prev) =>
      prev.map((msg, i) => (i === index ? { ...msg, feedback: "like" } : msg))
    );

    sendFeedback(1, index);
    setVisibleCommentIndex(null);
  };

  const handleThumbsDown = (index: number) => {
    // console.log("Thumbs Down clicked at index:", index);

    if (chatHistory[index].feedback === "dislike") {
      console.log("Already disliked.");
      return;
    }

    setChatHistory((prev) =>
      prev.map((msg, i) =>
        i === index ? { ...msg, feedback: "dislike" } : msg
      )
    );

    sendFeedback(0, index);
    setVisibleCommentIndex(index);
  };

  const handleSaveComment = async () => {
    
    if (comment.trim()) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/update_comment`,
          {
            feedback_id: feedbackId,
            comment: comment,
            trace_id: "",
            span_id: ""
            // token,
          }
        );
        // console.log("Comment saved:", response);
        toast.success("Comment saved successfully!");
        // const logMessageResponse =  await logMessage(
        //   uuid!,
        //   "process",
        //   "feedback",
        //   JSON.stringify({ comment })
        // );
        // console.log("Comment logged:", logMessageResponse);
      } catch (error) {
        console.error("Failed to save comment:", error);
        toast.error("Failed to save comment");
      }
    }
    setComment("");
    setVisibleCommentIndex(null);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        commentBoxRef.current &&
        !commentBoxRef.current.contains(event.target as Node)
      ) {
        setVisibleCommentIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCopy = (msgText: string) => {
    navigator.clipboard
      .writeText(msgText)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2500);
      })
      .catch((err) => console.error("Failed to copy text: ", err));
  };

  const loadingMessages: { [key: string]: string } = {
    eng_Latn: "Generating...",
    tel_Telu: "సృష్టిస్తున్నాను...", // Telugu
    hin_Deva: "प्रक्रिया जारी है...", // Hindi
    tam_Taml: "உருவாக்கப்படுகிறது...", // Tamil
  };

  const handleLanguageSelect = (langCode: string, name: string) => {
    setSelectLanguageLocal(langCode);
    // setSelectedLanguage(langCode);
    setSelectLanguageName(name);
    setIsDropdownOpen(false);
    // console.log(`Selected Language Code: ${langCode} ${name}`);
  };

  const handleToggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  //Voice recording UI
  const [recordingTime, setRecordingTime] = useState("0:00");

  useEffect(() => {
    let interval: any;
    if (isRecording) {
      const start = Date.now();
      interval = setInterval(() => {
        const elapsed = Math.floor((Date.now() - start) / 1000);
        const minutes = Math.floor(elapsed / 60);
        const seconds = elapsed % 60;
        setRecordingTime(`${minutes}:${seconds < 10 ? "0" : ""}${seconds}`);
      }, 1000);
    } else {
      setRecordingTime("0:00");
    }

    return () => clearInterval(interval);
  }, [isRecording]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/wav",
        });
        const uniqueFileName = `${uuidv4()}.wav`;
        const file = new File([audioBlob], uniqueFileName, {
          type: "audio/wav",
        });

        const formData = new FormData();
        formData.append("file", file);
        formData.append("trace_id", "");
        formData.append("span_id", "");

        try {
          setAudioUploading(true);
          const response = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/transcribe`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          //const result = response.data;
          // console.log("Audio detection response:", result);
          // toast.success("Audio processed successfully!");

          const transcript =
            response.data?.results?.transcript || "No transcript found";
          // console.log("Transcript:", transcript);

          setMessage(transcript);
          sendMessage();
        } catch (error) {
          console.error("Audio upload failed:", error);
          toast.error("Audio upload failed");
        } finally {
          setAudioUploading(false);
        }
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error("Failed to start recording:", error);
      toast.error("Microphone access denied");
    }
  };

  const stopRecordingAndSend = () => {
    mediaRecorderRef.current?.stop();
    setIsRecording(false);
  };

  const formatResponse = (text: string) => {
      if (!text) return text;

      let formatted = text;

      //  Convert numbered steps into bullets
      formatted = formatted.replace(/\d+\.\s+/g, "\n- ");

      //  Ensure bullets start on new line
      formatted = formatted.replace(/(\s|^)-\s*/g, "\n- ");

      //  Clean spacing
      formatted = formatted.replace(/\n{2,}/g, "\n\n");

      
    formatted = formatted.replace(
      /(\d(\.\d+)?)(\s+)([A-Z][a-zA-Z]+)/g,
      (match, num, _, space, word) => {
        const starters = ["Other", "The", "Note", "Additional"];
        if (starters.includes(word)) {
          return `${num}\n\n${word}`;
        }
        return match;
      }
    );
    //  Fix missing newline before "- Shift"
    formatted = formatted.replace(/([a-zA-Z])-\s/g, "$1\n- ");
    //  Fix missing newline before "-" after numbers/time (like 09:30-)
    formatted = formatted.replace(/(\d)-\s/g, "$1\n- ");

    formatted = formatted.replace(/\.([A-Z])/g, ".\n\n$1");
      return formatted.trim();
    };

  return (
    <div className="flex flex-col w-full max-w-5xl mx-auto mt-4 h-full ">
      <ToastContainer />
      <div
        ref={chatContainerRef}
        className="flex-1 px-4 custom-scrollbar overflow-y-auto"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {chatHistory.map((msg, index) => (
          <div key={index}>
            <div
              className={`flex ${
                msg.role === "user" ? "justify-end" : "justify-start"
              }`}
            >
              {msg.role === "assistant" && (
                <img
                  src={KshemaLogo}
                  alt="Bot Logo"
                  className="w-8 h-8 rounded-full mr-2"
                  style={{ marginTop: "-1px" }}
                />
              )}
            
            <div
                className={`p-3 rounded-[32px] mb-[20px] ${
                  msg.role === "user" ? "bg-blue-100" : "white"
                }`}
              >
                
                {msg.role === "assistant" && !msg.forLogin ? (
                  <div className="markdown-body">
                    <Streamdown animated caret="block">
                      {formatResponse(msg.content)}
                    </Streamdown>
                  </div>
                ) : (
                  msg.content
                )}
              </div>

            </div>
            {msg.role === "assistant" && !msg.isStreaming && (
              <div className="feedback-section">
                {/* Thumbs Up */}
                {/* {msg.feedback !== "like"  && ( */}
                <div
                  className={`like ${msg.feedback === "like" ? "active" : ""}`}
                  onClick={() => {
                    if (msg.feedback !== "like" && msg.feedback !== "dislike") {
                      handleThumbsUp(index);
                    }
                  }}
                  style={{
                    cursor:
                      msg.feedback === "dislike" ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa fa-thumbs-up text-xl" aria-hidden="true"></i>
                  {/* <i className="fa-regular fa-thumbs-up text-2xl" aria-hidden="true"></i> */}
                </div>
                {/* )} */}
                {/* Thumbs Down */}
                <div
                  className={`dislike ${
                    msg.feedback === "dislike" ? "active" : ""
                  }`}
                  onClick={() => {
                    if (msg.feedback !== "dislike" && msg.feedback !== "like") {
                      handleThumbsDown(index);
                    }
                  }}
                  style={{
                    cursor:
                      msg.feedback === "dislike" ? "not-allowed" : "pointer",
                  }}
                >
                  <i
                    className="fa fa-thumbs-down text-xl"
                    aria-hidden="true"
                  ></i>
                </div>
                {/* Text-to-Speech Button */}
                {/* <div
                  className="text-to-speech"
                  onClick={() => handleTextToSpeech(msg.text)}
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                >
                  <i className="fa fa-volume-up text-xl" aria-hidden="true"></i>
                </div> */}

                <div
                  className={`copy-text ${isCopied ? "active" : ""}`}
                  style={{ marginTop: "3px" }}
                >
                  <button onClick={() => handleCopy(msg.content)}>
                    <i className="fa fa-clone text-xl"></i>
                  </button>
                </div>
                {/* <div>
                  <i
                    className="fa-solid fa-arrow-rotate-left text-lg"
                    style={{ color: "darkgray", cursor: "pointer" }}
                  ></i>
                </div> */}
                {/* Comment Box (Visible only on Thumbs Down) */}
              </div>
            )}
            {visibleCommentIndex !== null && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <textarea
                    placeholder="Enter your comment..."
                    value={comment}
                    className="comment-box"
                    onChange={(e) => setComment(e.target.value)}
                  ></textarea>
                  <button className="save-btn" onClick={handleSaveComment}>
                    Save
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={() => setVisibleCommentIndex(null)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* {loading && (
        <div className="flex items-center space-x-2 mb-2">
          <img
            src={KshemaLogo}
            alt="Bot Logo"
            className="w-8 h-8 rounded-full"
          />
          <div className="p-3 rounded-full white text-gray-800 text-lg">
            {loadingMessages[selectLanguage] || "Generating..."}
          </div>
        </div>
      )} */}
      {audioUploading && (
        <div className="flex items-center justify-center my-4">
          <i className="fa fa-spinner fa-spin text-blue-600 text-2xl" />
          <span className="ml-2 text-gray-700">Processing voice input...</span>
        </div>
      )}
      <div className="language-sec">
        <div className="flex items-center gap-[10px]">
          <p className="profile-headings">Chat Language:</p>
          <div
            className="lang-display cursor-pointer"
            onClick={handleToggleDropdown}
          >
            {selectLanguageName}
            <img
              src={isDropdownOpen ? ArrowUp : ArrowDown}
              alt="Dropdown Icon"
              className="cursor-pointer arrow-click"
              onClick={handleToggleDropdown}
            />
          </div>
        </div>
        {isDropdownOpen && (
          <div className="language-dropdown">
            {languageOptions.map(({ name, code }) => (
              <div
                key={code}
                className="language-item"
                style={{
                  backgroundColor:
                    selectLanguage === code ? "#E4EDFE" : "transparent",
                }}
                onClick={() => handleLanguageSelect(code, name)}
              >
                {name}
              </div>
            ))}
          </div>
        )}
      </div>

      {isRecording ? (
        // 🎤 Show audio recording UI
        <div
          className="w-full bg-white shadow-md rounded-full flex items-center justify-between p-[19px] border border-gray-300 "
          style={{ boxShadow: "0px 4.27px 34.18px -4.27px #638cf352" }}
        >
          <button
            onClick={() => setIsRecording(false)}
            className="text-white bg-blue-900 w-6 h-6 rounded-full flex items-center justify-center"
          >
            <i className="fa fa-times text-sm" />
          </button>

          <div className="flex-1 mx-4 flex items-center space-x-1 overflow-hidden">
            {[...Array(20)].map((_, i) => (
              <div
                key={i}
                className="w-1 bg-blue-400 rounded"
                style={{
                  height: `${5 + Math.random() * 20}px`,
                  animation: "pulse 1s infinite ease-in-out",
                  animationDelay: `${i * 0.05}s`,
                }}
              />
            ))}
          </div>

          <span className="text-sm text-gray-700 mr-2">{recordingTime}</span>

          <button
            onClick={stopRecordingAndSend}
            className="text-white bg-blue-900 w-6 h-6 rounded-full flex items-center justify-center"
          >
            <i className="fa fa-check text-sm" />
          </button>
        </div>
      ) : (
        // 📝 Show normal input UI
        <div className="flex items-center bg-white p-2 shadow-md rounded-[32px] chat-input sticky bottom-0 w-full">
          <input
            type="text"
            placeholder="Ask anything you need"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="flex-1 pl-[18px] p-2 outline-none border-none text-gray-700"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                if (!loading) sendMessage();
              }
            }}
            disabled={loading || audioUploading}
          />

          {/* Dynamic button based on message */}
          {message.trim() ? (
            <button
              onClick={sendMessage}
              disabled={loading}
              style={{
                opacity: loading ? 0.5 : 1,
                pointerEvents: loading ? "none" : "auto",
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              <img src={Send} alt="Send Icon" className="send-img" />
            </button>
          ) : (
            <button
              onClick={isRecording ? stopRecordingAndSend : startRecording}
              title={isRecording ? "Stop Recording" : "Start Recording"}
              style={{ color: isRecording ? "red" : "black" }}
            >
              {isRecording ? (
                <i className="fa fa-stop text-xl text-red-600" />
              ) : (
                <div className="microphone-icon">
                  <img src={Microphone} alt="Mic Icon" className="" />
                </div>
              )}{" "}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ChatInput;
